import { render } from "./OutlineButton.vue?vue&type=template&id=d48e128a"
import script from "./OutlineButton.vue?vue&type=script&lang=js"
export * from "./OutlineButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"OutlineButton.vue"]])

export default __exports__